import React from 'react';
import { RiArrowDownSLine } from 'react-icons/ri';
import {  ZipCodeDropDownProps, ZipCodeInputProps } from '@interface';


const ZipCodeDropDown: React.FC<ZipCodeDropDownProps> = ({
    results,
    navigaterFunction,
}) => {
    return (
        <ul className="absolute left-0 w-full border border-gray-300 bg-white divide-y divide-gray-200 z-10 max-h-60 overflow-y-auto shadow-lg text-left">
            {results.map((result, index) => (
                <li
                    key={index}
                    className="px-4 py-2 text-[14px] font-semibold text-[#000] bg-[#fff] hover:bg-[#e1e1e1] cursor-pointer hover:underline"
                    onClick={() => navigaterFunction(result.value)}
                >
                    {result.label}
                </li>
            ))}
        </ul>
    );
};

export const ZipCodeInput: React.FC<ZipCodeInputProps> = ({
	value,
	onChange,
	toggleDropdown,
	setToggleDropdown,
	results,
	onSelect,
}) => {
	return (
		<div className="flex-grow relative w-auto border mt-2">
			<div className="relative w-full">
				<form
					className="flex px-2 py-2 items-center w-full"
					onClick={() => setToggleDropdown(!toggleDropdown)}
				>
					<input
						type="number"
						value={value}
						onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
							onChange(e.target.value)
						}
						placeholder="Enter a Zip Code..."
						className="[appearance:textfield] [&::-webkit-outer-spin-button]:appearance-none [&::-webkit-inner-spin-button]:appearance-none outline-none w-full"
						style={{ WebkitAppearance: 'none' }}
					/>
					<div className="cursor-pointer">
						<RiArrowDownSLine />
					</div>
				</form>
				{toggleDropdown && (
					<ZipCodeDropDown navigaterFunction={onSelect} results={results} />
				)}
			</div>
		</div>
	);
};
